var VerticalLayout3Module = /** @class */ (function () {
    function VerticalLayout3Module() {
    }
    return VerticalLayout3Module;
}());
export { VerticalLayout3Module };
